import { hideAlert } from 'actions/client';
import createHistory from 'history/createBrowserHistory';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux';
import Authentication from './components/Authentication';
import Dashboard from './components/Dashboard';
import Help from './components/Help';
import NotFound from './components/NotFound';
import Policies from './components/Policies';
import AlertDialog from './components/Utility/Dialogs/AlertDialog';

// import { Plugins } from '@capacitor/core';
// const { Device, Modals } = Plugins;

class App extends Component {
  history = createHistory();

  closeAlert = () => {
    if (
      this.props.alertCallbackRef !== null &&
      this.props.alertCallbackRef !== undefined
    ) {
      this.props.alertCallbackRef();
    }

    this.props.hideAlert();
  };

  componentDidMount() {
    const preventDefault = event => {
      if (event.target.type === 'number') {
        event.preventDefault();
      }
    };
    document.addEventListener('wheel', preventDefault, { passive: false });

    if (this.props.user && this.props.user.id && !window.Intercom) {
      window.Intercom('boot', {
        app_id: process.env.REACT_APP_INTERCOM_APP_ID,
        email: this.props.user.email,
        user_id: this.props.user.id,
        custom_launcher_selector: '#intercom-chat-hidden',
      });
    }
  }

  render() {
    return (
      <div>
        <ConnectedRouter history={this.history}>
          <Switch>
            <Redirect exact from="/" to="/dashboard" />
            <Route path="/dashboard" component={Dashboard} />
            <Route path="/auth" component={Authentication} />
            <Route path="/help" component={Help} />
            <Route path="/policies" component={Policies} />
            <Route component={NotFound} />
          </Switch>
        </ConnectedRouter>
        <AlertDialog
          open={this.props.showAlert}
          onClose={this.closeAlert}
          alertTitle={this.props.alertTitle}
          alertDescription={this.props.alertDescription}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const clientReducer = state.client;
  const authReducer = state.authentication;

  return {
    alertTitle: clientReducer.alertTitle,
    alertDescription: clientReducer.alertDescription,
    showAlert: clientReducer.showAlert,
    alertCallbackRef: clientReducer.alertCallbackRef,
    user: authReducer.user,
  };
};

const mapDispatchToProps = dispatch => ({
  hideAlert: () => dispatch(hideAlert()),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/App.jsx